import { NgTemplateOutlet } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  DestroyRef,
  HostBinding,
  inject,
  model,
  QueryList,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TabViewModule } from 'primeng/tabview';
import { TabDirective } from './directives/tab.directive';

@Component({
  selector: 'osp-tab-view',
  standalone: true,
  imports: [TabViewModule, NgTemplateOutlet],
  templateUrl: './tab-view.component.html',
  styleUrl: './tab-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabViewComponent implements AfterContentInit {
  private destroyRef = inject(DestroyRef);

  @HostBinding('class.osp-tab-view') protected hostCssClassEnabled = true;
  @ContentChildren(TabDirective) contentTabs!: QueryList<TabDirective>;
  activeIndex = model(0);
  tabs = signal<TabDirective[]>([]);

  ngAfterContentInit(): void {
    this.refreshContent();
    this.contentTabs.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.refreshContent());
  }

  private refreshContent(): void {
    this.tabs.set(this.contentTabs.toArray());
  }
}
